function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFreshDesk = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40pt",
  height: "40pt",
  viewBox: "0 0 40 40",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
  id: "surface1"
}, /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "rgb(14.509804%,75.686275%,43.529412%)",
    fillOpacity: 1
  },
  d: "M 19.9375 0 L 34.960938 0 C 36.300781 -0.0117188 37.589844 0.515625 38.539062 1.464844 C 39.484375 2.414062 40.011719 3.703125 40 5.046875 L 40 20.0625 C 40 31.078125 31.078125 40 20.0625 40 L 19.949219 40 C 8.933594 40.007812 0 31.082031 0 20.066406 C 0 9.023438 8.910156 0.113281 19.9375 0 Z M 19.9375 0 "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "rgb(100%,100%,100%)",
    fillOpacity: 1
  },
  d: "M 19.9375 8.910156 C 14.878906 8.910156 10.777344 13.007812 10.777344 18.066406 L 10.777344 24.296875 C 10.816406 25.960938 12.15625 27.304688 13.824219 27.339844 L 16.414062 27.339844 L 16.414062 20.1875 L 12.914062 20.1875 L 12.914062 18.1875 C 13.128906 14.421875 16.246094 11.476562 20.015625 11.476562 C 23.789062 11.476562 26.898438 14.414062 27.113281 18.1875 L 27.113281 20.1875 L 23.5625 20.1875 L 23.5625 27.347656 L 25.902344 27.347656 L 25.902344 27.460938 C 25.878906 29.007812 24.632812 30.253906 23.089844 30.273438 L 20.296875 30.273438 C 20.066406 30.273438 19.816406 30.386719 19.816406 30.613281 C 19.828125 30.871094 20.035156 31.078125 20.296875 31.089844 L 23.109375 31.089844 C 25.109375 31.078125 26.730469 29.457031 26.742188 27.453125 L 26.742188 27.226562 C 28.121094 26.917969 29.097656 25.6875 29.085938 24.273438 L 29.085938 18.1875 C 29.199219 13.027344 25.105469 8.914062 19.925781 8.914062 Z M 19.9375 8.910156 "
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFreshDesk, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/freshDesk.adf44172.svg";
export { ForwardRef as ReactComponent };